import { useRef, useState } from "react";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const Rooms = () => {
  const desktopSliderRef = useRef(null);

  const roomsData = [
    {
      id: 1,
      icon: [
        { id: 1, img: "/assets/room-1.JPG" },
        { id: 2, img: "/assets/club-room.png" },
        { id: 3, img: "/assets/site-room.png" },
      ],
      name: "Executive Room",
      content:
        "Spacious room with modern amenities and a comfortable king-size bed",
    },
    {
      id: 2,
      icon: [
        { id: 1, img: "/assets/room-2.JPG" },
        { id: 2, img: "/assets/executive-room.png" },
        { id: 3, img: "/assets/site-room.png" },
      ],
      name: "Club Room",
      content: "Comfortable room with modern décor and cozy bedding.",
    },
    {
      id: 3,
      icon: [
        { id: 1, img: "/assets/room-3.JPG" },
        { id: 2, img: "/assets/club-room.png" },
        { id: 3, img: "/assets/executive-room.png" },
      ],
      name: "Suite Room",
      content: "Spacious suite with elegant décor and premium amenities.",
    },
    {
      id: 4,
      icon: [
        { id: 1, img: "/assets/room-4.JPG" },
        { id: 2, img: "/assets/club-room.png" },
      ],
      name: "Deluxe Room",
      content:
        "Comfortable deluxe room with modern furnishings and cozy bedding.",
    },
  ];

  const [activeIndexes, setActiveIndexes] = useState({});

  // 🔹 Image Prev
  const handlePrev = (roomId, total) => {
    setActiveIndexes((prev) => ({
      ...prev,
      [roomId]: prev[roomId] > 0 ? prev[roomId] - 1 : total - 1,
    }));
  };

  // 🔹 Image Next
  const handleNext = (roomId, total) => {
    setActiveIndexes((prev) => ({
      ...prev,
      [roomId]: prev[roomId] < total - 1 ? prev[roomId] + 1 : 0,
    }));
  };

  // 🔹 Slider Forward
  const handleForward = () => {
    if (!desktopSliderRef.current) return;

    const firstCard = desktopSliderRef.current.querySelector(".room-card");

    const cardWidth = firstCard?.offsetWidth || 400;

    desktopSliderRef.current.scrollBy({
      left: cardWidth + 24, // 24px gap
      behavior: "smooth",
    });
  };

  // 🔹 Slider Back
  const handleBack = () => {
    if (!desktopSliderRef.current) return;

    const firstCard = desktopSliderRef.current.querySelector(".room-card");

    const cardWidth = firstCard?.offsetWidth || 400;

    desktopSliderRef.current.scrollBy({
      left: -(cardWidth + 24),
      behavior: "smooth",
    });
  };

  return (
    <section className="bg-[#FFFEF2] w-full py-5 md:py-20">
      <div>
        {/* Header */}
        <div className="flex items-center justify-between px-5 md:px-20">
          <h2 className="text-[30px] md:text-[54px] lg:text-[64px] font-calson text-primary">
            Explore Our Rooms
          </h2>

          {/* Desktop Arrows */}
          <div className="hidden md:flex items-center gap-3">
            <button onClick={handleBack}>
              <img
                src="/assets/back-arrow.svg"
                className="w-10 h-10"
                alt="Back"
              />
            </button>

            <button onClick={handleForward}>
              <img
                src="/assets/front-arrow.svg"
                className="w-10 h-10"
                alt="Forward"
              />
            </button>
          </div>
        </div>

        {/* Desktop Slider */}
        <div
          ref={desktopSliderRef}
          className="pl-20 hidden md:flex mt-10 gap-6 overflow-x-auto scroll-smooth no-scrollbar"
        >
          {roomsData.map((dat) => {
            const currentIndex = activeIndexes[dat.id] || 0;
            const totalImages = dat.icon.length;

            return (
              <div key={dat.id} className="room-card w-[390px] flex-shrink-0">
                <div className="relative bg-white border border-[#E7E1CF]">
                  {/* Image */}
                  <div className="w-[390px] h-[390px] overflow-hidden relative">
                    <img
                      src={dat.icon[currentIndex].img}
                      alt={dat.name}
                      className="w-full h-full object-cover"
                    />

                    <div className="absolute inset-0 bg-[linear-gradient(180.29deg,rgba(0,0,0,0)_82.99%,rgba(0,0,0,0.42)_91.37%)]" />
                  </div>

                  {/* Image Counter */}
                  <div className="absolute left-4 bottom-4 text-white text-[26px] font-creto">
                    {currentIndex + 1} / {totalImages}
                  </div>

                  {/* Image Arrows */}
                  <div className="absolute right-4 bottom-4 flex gap-4">
                    <button onClick={() => handlePrev(dat.id, totalImages)}>
                      <GoArrowLeft className="text-white text-[26px]" />
                    </button>

                    <button onClick={() => handleNext(dat.id, totalImages)}>
                      <GoArrowRight className="text-white text-[26px]" />
                    </button>
                  </div>
                </div>

                {/* Divider */}
                <div className="h-[2px] bg-[#D7D2C2] mt-4" />

                {/* Content */}
                <div className="mt-6 text-center">
                  <h3 className="text-primary text-[36px] font-calson">
                    {dat.name}
                  </h3>
                  <p className="mt-3 text-[18px] text-primary/70 max-w-[320px] mx-auto">
                    {dat.content}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden mt-10 grid gap-6 px-5">
          {roomsData.map((dat) => {
            const currentIndex = activeIndexes[dat.id] || 0;
            const totalImages = dat.icon.length;

            return (
              <div key={dat.id}>
                <div className="relative bg-white border border-[#E7E1CF]">
                  <div className="w-full h-[250px] overflow-hidden">
                    <img
                      src={dat.icon[currentIndex].img}
                      alt={dat.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="mt-4 text-center">
                  <h3 className="text-primary text-[24px] font-calson">
                    {dat.name}
                  </h3>
                  <p className="text-primary/70 text-sm">{dat.content}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Hide Scrollbar */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { scrollbar-width: none; }
      `}</style>
    </section>
  );
};

export default Rooms;
